import React, { memo, useEffect } from "react";
import sensors from "sa-sdk-javascript";
import Modal from "./Modal";
import useControl from "../hooks/useControl";
import "./styles/scss/StartStep.scss";
import correct from "./styles/scss/img/start_step/correct.png";
import error from "./styles/scss/img/start_step/error.png";
import { playGame } from "../common";

function App(props) {
	const { isShow, onClose } = props;
	const progressItem = [
		"1. 检测运行环境",
		"2. 检查游戏平台更新",
		"3. 登录游戏账号",
	];

	const { onProcessGame } = useControl();

	const {
		progress_step: step,
		progress_info: info,
		isErr,
		isSucc,
		playParam,
		orderInfo = {},
	} = onProcessGame || {};

	const gamename = playParam?.[1];

	const gameid = playParam?.[5];

	const { isMemberPlay, isNetbarPlay } = orderInfo;

	useEffect(() => {
		if (!isShow) return;

		if (isSucc) {
			setTimeout(() => {
				onClose();
			}, 1500);
		}
	}, [isShow, onClose, isSucc]);

	useEffect(() => {
		if (!isShow) return;

		const sensorsData = {
			gameid,
			gamename,
			mode: isMemberPlay
				? "member_order"
				: isNetbarPlay
				? "netbar_order"
				: "game_order",
		};

		sensors.track("yizhan_rungames_process", {
			...sensorsData,
			status: 0,
		});

		if (isErr) {
			sensors.track("yizhan_rungames_process", {
				...sensorsData,
				status: 1,
				result: 2,
				errorcode: info,
			});
		} else if (isSucc) {
			//2 上号插件更新完成 <=> 检测运行环境
			//10 正在登录平台 <=> 检查游戏平台更新
			//12 上号完成 <=> 登录游戏账号

			sensors.track("yizhan_rungames_process", {
				...sensorsData,
				status: 1,
				result: 1,
			});
		}
	}, [
		isShow,
		gameid,
		gamename,
		isMemberPlay,
		isNetbarPlay,
		isErr,
		isSucc,
		info,
	]);

	return (
		<Modal className="popup-start-step" visible={isShow} onClose={onClose}>
			<div className="head">
				<div className="title">绿洲上号器</div>
				<div className="name">
					<div title={gamename}>正在启动 {gamename}</div>
					<div>
						（{step > progressItem.length ? progressItem.length : step}/
						{progressItem.length}）
					</div>
				</div>
				<div className="tips">小Tips：共享账号，请勿在游戏内充值</div>
			</div>

			<div className="step">
				{progressItem.map((ele, index) => {
					return (
						<div key={index}>
							<div>{ele}</div>
							<div
								className={
									step === index + 1
										? isErr
											? "error"
											: ""
										: step > index + 1
										? "succ"
										: ""
								}
							>
								{step === index + 1 ? (
									isErr ? (
										<>
											失败
											<img src={error} alt="" />
										</>
									) : (
										"...检测中"
									)
								) : step > index + 1 ? (
									<>
										完成
										<img src={correct} alt="" />
									</>
								) : (
									""
								)}
							</div>
						</div>
					);
				})}
			</div>
			{isErr && (
				<button
					type="button"
					className="retry"
					onClick={() => {
						playGame(playParam);
					}}
				>
					重试
				</button>
			)}
		</Modal>
	);
}

export default memo(App);
